<template>
  <section class="home__section about" id="about">
    <h2 class="heading--h2">
      <span class="highlight">about</span> vnoun
      <img src="/images/heading-wave.svg" alt="image" class="wave" />
    </h2>
    <div class="about__content">
      <p class="about__paragraph">
        vnoun is an ecommerce system designed for fashion and clothes shops.
      </p>

      <p class="about__paragraph">
        the system was built using the best technologies and the code is clean,
        extendable and mainatable.
      </p>

      <p class="about__paragraph">
        it has all of the features that are required on any ecommerce system.
      </p>

      <img
        src="/images/circle-red.svg"
        alt="circle"
        class="about__img--circle"
      />
      <div class="about__right">
        <img src="/images/about-man.svg" alt="image" class="about__img--man" />
        <img
          src="/images/about-line.svg"
          alt="image"
          class="about__img about__img--line"
        />
        <img
          src="/images/about-vs-code.svg"
          alt="image"
          class="about__img about__img--vs"
        />
        <img
          src="/images/background-js.svg"
          alt="image"
          class="about__img about__img--js"
        />

        <img
          src="/images/background-handler.svg"
          alt="image"
          class="about__img about__img--handler"
        />

        <img
          src="/images/background-tag.svg"
          alt="image"
          class="about__img about__img--tag"
        />

        <img
          src="/images/background-css3.svg"
          alt="image"
          class="about__img about__img--html"
        />
      </div>
    </div>
    <a
      class="btn btn--gredient btn--huge"
      href="https://vnoun.onrender.com/home"
      target="_blank"
    >
      view demo
    </a>
  </section>
</template>
